module.exports = __webpack_public_path__ + "img/img-box-products-magento-1x-left.b08e6f94.png";